import Range from '@/components/rangeSelect';
import { Translation } from '@/hoslog-intl';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { HostFormValues } from './premium-stores/form/ManageHostManagement';

type SkillRow = {
  name: 'appearance' | 'conversationStyle' | 'alcoholTolerance' | 'atmosphere';
  label: string;
  low: string;
  high: string;
};

const skillRows: SkillRow[] = [
  {
    name: 'appearance',
    label: 'storeManagement.hostManagement.form.personalityAndSkillset.appearance',
    low: 'storeManagement.hostManagement.form.personalityAndSkillset.cuteStyle',
    high: 'storeManagement.hostManagement.form.personalityAndSkillset.coolStyle',
  },
  {
    name: 'conversationStyle',
    label: 'storeManagement.hostManagement.form.personalityAndSkillset.conversationStyle',
    low: 'storeManagement.hostManagement.form.personalityAndSkillset.listener',
    high: 'storeManagement.hostManagement.form.personalityAndSkillset.speaker',
  },
  {
    name: 'alcoholTolerance',
    label: 'storeManagement.hostManagement.form.personalityAndSkillset.alcoholTolerance',
    low: 'storeManagement.hostManagement.form.personalityAndSkillset.cantDrink',
    high: 'storeManagement.hostManagement.form.personalityAndSkillset.drinkable',
  },
  {
    name: 'atmosphere',
    label: 'storeManagement.hostManagement.form.personalityAndSkillset.atmosphere',
    low: 'storeManagement.hostManagement.form.personalityAndSkillset.healing',
    high: 'storeManagement.hostManagement.form.personalityAndSkillset.livenThingsUp',
  },
];

const getSkillValue = (items: Record<string, string | number | null | undefined> | undefined, fieldId: string) => {
  if (!items) return '';
  const value = items[fieldId];
  return typeof value === 'number' ? String(value) : typeof value === 'string' ? value : '';
};

type Props = { hostDetails?: HostFormValues };

export const SkillsSet = ({ hostDetails }: Props) => {
  const { control, setValue } = useFormContext<Record<string, string>>();

  useEffect(() => {
    if (!hostDetails?.skills) return;
    skillRows.forEach((skill) => {
      const fieldName = `skills_${skill.name}`;
      const value = getSkillValue(hostDetails.skills, skill.name);
      if (value !== '') {
        setValue(fieldName, value, { shouldDirty: false, shouldTouch: false });
      }
    });
  }, [hostDetails, setValue]);

  return (
    <div className="flex gap-5 sm:gap-10 md:gap-15 lg:gap-20 mt-6">
      <div className=" ">
        <p className="text-base font-bold w-[200px] xl:w-[259px] shrink-0 text-wrap pl-12">
          <Translation id="storeManagement.hostManagement.form.personalityAndSkillset.title" />
        </p>
      </div>
      <div className="grid grid-cols-1 gap-y-6 w-full">
        {skillRows.map((skill, index) => {
          const { name } = skill;
          const row = skillRows[index] ?? skillRows[0];
          return (
            <div key={name}>
              <Controller
                name={`skills_${name}`}
                control={control}
                defaultValue={''}
                render={({ field }) => {
                  const valueForRange =
                    field.value === '' || field.value == null || field.value === '0' ? 3 : Number(field.value);
                  return (
                    <Range row={row} value={valueForRange} onRangeChange={(range) => field.onChange(String(range))} />
                  );
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
